import React from "react";
import NewUserNavBar from "./NewUser/Navbar";
export default function Navbar() {
  return (
    <>
      <NewUserNavBar />
    </>
  );
}
